import React from "react";
import "./SidebarModule.scss";
import { ReactComponent as Templates } from "static/icons/templates.svg";
import { useSelector } from "react-redux";
import SelectFilterField from "../SelectFilterField";


const SidebarModule = () => {

  const { selectorsFieldData } = useSelector((state) => state.statisticsFilters);

  return (
    <>
      <div
        className={"sidebar-module"}
      >
        <div className={"sidebar-module__header"}>
          <Templates />
          <span className={"sidebar-module__header_title"}>Report settings</span>
        </div>
        <div className={"sidebar-module__content"}>
          {selectorsFieldData?.map((selectField, index) => {
            return (
              <SelectFilterField {...selectField} key={index} />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SidebarModule;
